// extracted by mini-css-extract-plugin
export default {"root":"IXW1E8uhxV0pB3lboNsr","time":"FXMtlvA2CFSF03J0Oxux"};